var render = function render(){var _vm=this,_c=_vm._self._c;return _c('summary-count',{attrs:{"title":"Awaiting Onboarding","is-loading":_vm.isLoading,"count":_vm.count,"count-class":'tw-text-yellow-600',"caption":'New Prescriptions',"caption-class":'tw-text-yellow-600',"clickable":true},on:{"cardClicked":_vm.gotoPrescriptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }